import { get, system } from 'styled-system';
var iconSizes = system({
  iconSize: {
    property: 'fontSize',
    scale: 'iconSizes',
    transform: function transform(size, scale) {
      var iconSize = get(scale, size, size);
      iconSize = iconSize.toString();

      if (/^[0-9]+$/.test(iconSize)) {
        iconSize += 'px';
      }

      return iconSize;
    }
  }
});
export default iconSizes;